import React from "react";
import "./App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Header } from "./components/Header";
import { Hero } from "./components/Hero";
import { Services } from "./components/Services";
import { Reviews } from "./components/Reviews";
import { About } from "./components/About";
import { Footer } from "./components/Footer";
import { AdminPanel } from "./components/AdminPanel";
import { TermsAndConditions } from "./components/TermsAndConditions";
import { PrivacyPolicy } from "./components/PrivacyPolicy";
import { RefundPolicy } from "./components/RefundPolicy";
import { TrackingPage } from "./components/TrackingPage";
import { BookDelivery } from "./components/BookDelivery";
import { Stats } from "./components/Stats";
import { ChatWidget } from "./components/ChatWidget";
import { Fleet } from "./components/Fleet";
import { LocationPage } from "./components/LocationPage";
import { FAQ } from "./components/FAQ";
import { InvoiceGenerator } from "./components/InvoiceGenerator";
import { BlogList } from "./components/BlogList";
import { BlogPost } from "./components/BlogPost";
import { CookieBanner } from "./components/CookieBanner";
import { CookiePolicy } from "./components/CookiePolicy";

const HomePage = () => {
  return (
    <div className="min-h-screen">
      <Header />
      <main>
        <Hero />
        <Stats />
        <Services />
        <Fleet />
      </main>
      <Footer />
    </div>
  );
};

const AboutPage = () => {
  return (
    <div className="min-h-screen">
      <Header />
      <main>
        <About />
      </main>
      <Footer />
    </div>
  );
};

const TermsPage = () => {
  return <TermsAndConditions />;
};

const PrivacyPage = () => {
  return <PrivacyPolicy />;
};

const RefundPage = () => {
  return <RefundPolicy />;
};

const TrackingPageWrapper = () => {
  return (
    <div className="min-h-screen">
      <Header />
      <main>
        <TrackingPage />
      </main>
      <Footer />
    </div>
  );
};

const BookDeliveryPageWrapper = () => {
  return (
    <div className="min-h-screen">
      <Header />
      <main>
        <BookDelivery />
      </main>
      <Footer />
    </div>
  );
};

const ReviewsPageWrapper = () => {
  return (
    <div className="min-h-screen">
      <Header />
      <main>
        <Reviews />
      </main>
      <Footer />
    </div>
  );
};

const LocationPageWrapper = () => {
  return (
    <div className="min-h-screen">
      <Header />
      <main>
        <LocationPage />
      </main>
      <Footer />
    </div>
  );
};

const FAQPageWrapper = () => {
  return (
    <div className="min-h-screen">
      <Header />
      <main>
        <FAQ />
      </main>
      <Footer />
    </div>
  );
};

const BlogListWrapper = () => {
  return (
    <div className="min-h-screen">
      <Header />
      <main>
        <BlogList />
      </main>
      <Footer />
    </div>
  );
};

const BlogPostWrapper = () => {
  return (
    <div className="min-h-screen">
      <Header />
      <main>
        <BlogPost />
      </main>
      <Footer />
    </div>
  );
};

const CookiePolicyWrapper = () => {
  return (
    <div className="min-h-screen">
      <Header />
      <main>
        <CookiePolicy />
      </main>
      <Footer />
    </div>
  );
};

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <Routes>
          <Route path="/" element={<HomePage />} />
          <Route path="/about" element={<AboutPage />} />
          <Route path="/terms" element={<TermsPage />} />
          <Route path="/privacy" element={<PrivacyPage />} />
          <Route path="/refund" element={<RefundPage />} />
          <Route path="/track" element={<TrackingPageWrapper />} />
          <Route path="/book" element={<BookDeliveryPageWrapper />} />
          <Route path="/reviews" element={<ReviewsPageWrapper />} />
          <Route path="/admin" element={<AdminPanel />} />
          <Route path="/location/:location" element={<LocationPageWrapper />} />
          <Route path="/faq" element={<FAQPageWrapper />} />
          <Route path="/blog" element={<BlogListWrapper />} />
          <Route path="/blog/:slug" element={<BlogPostWrapper />} />
          <Route path="/cookies" element={<CookiePolicyWrapper />} />
        </Routes>
        {/* AI Chat Widget - Available on all pages */}
        <ChatWidget />
        {/* Cookie consent banner - first-visit compliance */}
        <CookieBanner />
      </BrowserRouter>
    </div>
  );
}

export default App;